
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.038 5.478C6.594 8.687 8.548 10.885 12 12c3.452-1.115 5.406-3.313 5.962-6.522a1.5 1.5 0 0 0-1.491-1.728H7.529a1.5 1.5 0 0 0-1.491 1.728ZM3.75.75h16.5M7.529 20.25a1.5 1.5 0 0 1-1.491-1.727C6.594 15.314 8.548 13.116 12 12c3.452 1.116 5.406 3.314 5.962 6.523a1.5 1.5 0 0 1-1.491 1.727Zm-3.779 3h16.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    